import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapUI from './contents/MapUI';

const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoicm9yaW9wMiIsImEiOiJjbGVmY2p3Y3QwcGsyM3VxcXR3MzVmdGNqIn0.bKksh0sQpm6vQuV-tZjj7g';
const DATA_URL = '/api/getClusterEdges';

function App({setShow}) {
  const mapContainer = useRef(null);

  let data = {}
  data['color'] = '';
  data['cluster_id'] = '';

  useEffect(() => {
      (async () => {
        await fetch("/api/getShipping", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ data })
        })
          .then(res => {
            return res.json()
          })
          .then(data => {
            console.log(data.features);
          })
          .catch(error => console.log(error));
      })()
  }, []);

  useEffect(() => {
    mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/light-v11',
      center: [126.9779, 37.5665],
      zoom: 11,
      pitch: 50,
      pitchWithRotate: true,
      antialias: true
    });

    map.on('load', () => {
      let data = {}
      data['color'] = 'Wistia';
      data['cluster_id'] = '';

      // Load the GeoJSON data
      fetch("/api/getClusterEdges", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ data })
        })
        .then(response => response.json())
        .then(data => {
          // Add a new source and layer for each polygon in the GeoJSON data
          data.features.forEach(feature => {
            const sourceId = `source-${feature.properties.cluster_id}`;
            const layerId = `layer-${feature.properties.cluster_id}`;

            map.addSource(sourceId, {
              type: 'geojson',
              data: feature
            });

            map.addLayer({
              id: layerId,
              type: 'fill-extrusion',
              source: sourceId,
              paint: {
                'fill-extrusion-height': feature.properties.grade,
                'fill-extrusion-base': 0,
                'fill-extrusion-opacity': 0.5,
                'fill-extrusion-color': feature.geometry.fillColor,
              }
            });
          });
        });
    });

    return () => map.remove();
  }, []);

  return <div id="mapboxgl" ref={mapContainer} style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }} ><MapUI setShow={setShow} /></div>;
}

export default App;
